<div class="failed" *ngIf="slip">
    <div class="note" *ngFor="let error of slip.betslipErrors$ | async">
        <div *msShowInEpcot="{ showInEpcot: false, module: module }">
            <!-- TODO: error.type has never value 'info' not sure what was tested here -->
            <i [ngClass]="error.type.toString() === 'info' ? 'theme-info-i' : 'theme-error-i warning-color'"></i
            ><span [innerHTML]="error.message"></span>
        </div>
        <div *msShowInEpcot="{ showInEpcot: true, module: module }">
            <ms-epcot-notification [message]="error.message" [notificationType]="error.type" />
        </div>
    </div>
    <div class="picks">
        <div class="pick" *ngFor="let pickInfo of slip.picks" [ngClass]="{ locked: pickInfo.isLocked || pickInfo.isFinished }">
            <div class="names-box {{ pickInfo.pickClass }}">
                <ng-container *ngTemplateOutlet="pickInfo.template; context: { pick: pickInfo.pick, messages: messages, hideActionButton: true }" />
                <bs-digital-pick-odds [pick$]="pickInfo.pick$" [oddsDisplayFormat]="oddsDisplayFormat" />
            </div>
            <ng-container *msShowInEpcot="{ showInEpcot: false, module: module }">
                <div class="pc-text betslip-error-container" *ngIf="pickInfo.errors | async as pickErrors">
                    <a class="linkbox betslip-error-pick theme-error-i" *ngIf="pickInfo.isLocked || pickInfo.isFinished">
                        <p>{{ messages.common.GlobalOddsChanged }}</p>
                    </a>
                    <!-- TODO: error.type has never value 'info' not sure what was tested here -->
                    <a
                        class="linkbox betslip-error-pick"
                        *ngFor="let error of pickErrors"
                        [ngClass]="error.type.toString() === 'info' ? 'theme-info-i' : 'theme-error-i ' + error.type">
                        <p [innerHTML]="error.message"></p>
                    </a>
                </div>
            </ng-container>
            <ng-container *msShowInEpcot="{ showInEpcot: true, module: module }">
                <div class="betslip-error-notification" *ngIf="pickInfo.errors | async as pickErrors">
                    <ng-container *ngIf="pickInfo.isLocked || pickInfo.isFinished; else notExtendedMessage">
                        <ms-epcot-notification [message]="messages.common.GlobalOddsChanged" [notificationType]="'error'" />
                    </ng-container>
                    <ng-template #notExtendedMessage>
                        <!-- TODO: error.type has never value 'info' not sure what was tested here -->
                        <ms-epcot-notification
                            *ngFor="let error of pickErrors"
                            [message]="error.message"
                            [notificationType]="error.type.toString() === 'info' ? 'info' : 'error'" />
                    </ng-template>
                </div>
            </ng-container>
        </div>
    </div>
</div>
